import { isEmpty } from 'ramda'
import { hasUserType } from './config'

const prependProtocol = url =>
  (url.indexOf('http://') === 0 || url.indexOf('https://') === 0)
    ? url
    : `http://${url}`

export default (fields, me) => {
  return {
    input: {
      firstName: fields.firstName,
      lastName: fields.lastName,
      emailAddress: fields.emailAddress,
      jobId: fields.jobId,
      phoneNumber: !isEmpty(fields.phoneNumber) ? fields.phoneNumber : null,
      website: !isEmpty(fields.websiteAddress) ? prependProtocol(fields.websiteAddress) : null,
      attachments: fields.attachments,
      memberNumber: hasUserType({ me })
        ? me.id
        : !isEmpty(fields.memberNumber) ? fields.memberNumber : null
    }
  }
}
